import React from "react";
import HowWeDoItCard from "./HowWeDoItCard";

const ServiceItem = ({
  serviceNumber,
  title,
  paragraphs = [],
  steps = [],
  reversed = false,
  theme = "light", // 'light' | 'tinted' | 'dark'
}) => {
  const isDark = theme === "dark";
  const isTinted = theme === "tinted";

  const sectionBgClass = isDark
    ? "bg-[#1E6C56]"
    : isTinted
    ? "bg-[#F4F9F6]"
    : "bg-white";

  const cardVariant = isDark ? "dark" : isTinted ? "white" : "light";

  const eyebrowColorClass = isDark ? "text-[#F5C955]" : "text-[#EF8702]";
  const titleColorClass = isDark ? "text-white" : "text-[#111827]";
  const paragraphColorClass = isDark ? "text-emerald-50/90" : "text-[#4B5563]";

  return (
    <div className={`w-full ${sectionBgClass} py-14 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8`}>
      <div className="w-full max-w-7xl mx-auto">
        <div
          className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center ${
            reversed ? "lg:grid-flow-dense" : ""
          }`}
          data-aos="fade-up"
        >
          {/* Text Column */}
          <div
            className={`lg:col-span-6 flex flex-col justify-center ${
              reversed ? "lg:col-start-7" : ""
            }`}
          >
            <span
              className={`${eyebrowColorClass} text-xs sm:text-sm font-black tracking-[0.16em] uppercase mb-2 font-['Axiforma',sans-serif]`}
            >
              {serviceNumber}
            </span>
            <h3
              className={`text-2xl sm:text-3xl lg:text-[34px] font-extrabold ${titleColorClass} tracking-tight leading-snug sm:leading-[1.3] font-['Axiforma',sans-serif] mb-5`}
            >
              {title}
            </h3>
            <div className={`space-y-4 text-sm sm:text-base leading-relaxed ${paragraphColorClass} font-normal`}>
              {paragraphs.map((p, idx) => (
                <p key={idx}>{p}</p>
              ))}
            </div>
          </div>

          {/* Card Column */}
          <div
            className={`lg:col-span-6 flex items-center justify-center ${
              reversed ? "lg:col-start-1" : ""
            }`}
          >
            <HowWeDoItCard steps={steps} variant={cardVariant} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceItem;
